/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import moment from "moment";
import { FormattedDate } from "react-intl";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { AgGridColumn, AgGridReact } from "ag-grid-react";

import FormFilter from "../../shared/forms/FormFilter/FormFilter";
import Filters from "../../shared/forms/FormFilter/Filters";
import Buttons from "../../shared/forms/FormFilter/Buttons";
import Field from "../../shared/forms/Field";
import FormCalendarRange from "../../shared/forms/FormFields/FormCalendarRange";
import FormDropDown from "../../shared/forms/FormFields/FormDropDown";

import FieldTextArea from "../../shared/controls/fieldTextArea";
import ButtonIcon from "../../shared/controls/ButtonIcon";
import agGridHelper from "../../shared/ag-grid-helper";
import useForm from "../../shared/forms/useForm";
import alerts from "../../shared/alerts";

import useApiSalidasEmpleado from "../../api/administracion/useApiSalidasEmpleado";
import SalidasEmpleadoDetalle from "./salidasEmpleadoDetalle";

const ESTATUS_SALIDA = {
    POR_AUTORIZAR: 171,
    AUTORIZADO: 172,
    RECHAZADO: 173,
    SALIDA: 430,
};

const filtroInicial = {
    fecha: [moment().startOf("month")._d, moment().endOf("day")._d],
    empleadoId: null,
    departamentoId: null,
    tipoId: null,
    estatusId: null,
};

const SalidasEmpleado = ({
    tipoSeccion = null,
    esSeccionAutorizar = false,
    esSeccionSalida = false,
    soloLectura = false,
    ocultarEditar = false
}) => {
    const api = useApiSalidasEmpleado();

    const esAutorizar = esSeccionAutorizar || tipoSeccion === "autorizar";
    const esSalida = esSeccionSalida || tipoSeccion === "salida";
    const esCaptura = !esAutorizar && !esSalida;

    const [datos, setDatos] = useState([]);
    const [salidaEmpleadoId, setSalidaEmpleadoId] = useState(null);

    const {
        values: filter,
        onChange: onFilterChange,
        onClear,
    } = useForm(filtroInicial);

    const [verModalRechazo, setVerModalRechazo] = useState(false);
    const [comentarioRechazo, setComentarioRechazo] = useState("");
    const [salidaRechazarId, setSalidaRechazarId] = useState(null);

    const puedeEditar = !soloLectura;

const filtrar = async (filtro) => {
    const filtroFinal = {
        ...filtro,
        esSeccionAutorizar: esAutorizar,

        ...(esAutorizar
            ? {
                tipoSeccion: "autorizar",
                estatusId: ESTATUS_SALIDA.POR_AUTORIZAR
            }
            : {}),

        ...(esSalida
            ? {
                tipoSeccion: "salida",
                estatusId: ESTATUS_SALIDA.AUTORIZADO
            }
            : {})
    };

    const result = await api.filtrar(filtroFinal);
    setDatos(result);
};

    const nuevo = () => {
        setSalidaEmpleadoId(0);
    };

    const editar = (id) => {
        setSalidaEmpleadoId(id);
    };

    const autorizar = async (id) => {
        if (
            await alerts.preguntarSiNo("Autorizar pase de salida, ¿deseas continuar?")
        ) {
            await api.autorizar(id);
            await filtrar(filter);
        }
    };

    const abrirRechazo = async (id) => {
        if (
            await alerts.preguntarSiNo("Rechazar pase de salida, ¿deseas continuar?")
        ) {
            setComentarioRechazo("");
            setSalidaRechazarId(id);
            setVerModalRechazo(true);
        }
    };

    const rechazar = async () => {
        await api.rechazar(salidaRechazarId, {
            comentarios: comentarioRechazo,
        });

        setVerModalRechazo(false);
        setComentarioRechazo("");
        setSalidaRechazarId(null);

        await filtrar(filter);
    };

    const registrarSalida = async (id) => {
        if (
            await alerts.preguntarSiNo(
                "Registrar salida del empleado, ¿deseas continuar?"
            )
        ) {
            await api.registrarSalida(id);
            await filtrar(filter);
        }
    };

    const DateTimeCellRenderer = ({ value }) => {
        if (!value) return null;

        return (
            <div>
                <FormattedDate value={value} weekday="short" /> &nbsp;
                {moment(value).format("DD/MM/YYYY HH:mm")}
            </div>
        );
    };

    const ButtonsHeader = () => (
        <div className="ag-grid header-icons">
            {esCaptura && puedeEditar && (
                <ButtonIcon
                    title="Agregar"
                    className="grid-action"
                    iconName="MdAddBox"
                    onClick={nuevo}
                />
            )}
        </div>
    );

    const ButtonsDetail = ({ data, context }) => (
        <div className="ag-grid row-icons">
            <ButtonIcon
                title="Ver / Editar"
                iconName="FaRegEdit"
                onClick={() => context.onEdit(data.id)}
            />
        </div>
    );

    const AutorizarCellRenderer = ({ data }) => {
        if (
            soloLectura ||
            !esAutorizar ||
            data?.estatusId !== ESTATUS_SALIDA.POR_AUTORIZAR
        ) {
            return null;
        }

        return (
            <div className="d-flex align-items-center justify-content-center">
                <button
                    title="Autorizar"
                    type="button"
                    className="button-icon"
                    onClick={() => autorizar(data.id)}
                >
                    <i className="pi pi-check-circle text-success" />
                </button>
            </div>
        );
    };

    const RechazarCellRenderer = ({ data }) => {
        if (
            soloLectura ||
            !esAutorizar ||
            data?.estatusId !== ESTATUS_SALIDA.POR_AUTORIZAR
        ) {
            return null;
        }

        return (
            <div className="d-flex align-items-center justify-content-center">
                <button
                    title="Rechazar"
                    type="button"
                    className="button-icon"
                    onClick={() => abrirRechazo(data.id)}
                >
                    <i className="pi pi-times-circle text-danger" />
                </button>
            </div>
        );
    };

    const SalidaCellRenderer = ({ data }) => {
        if (
            soloLectura ||
            !esSalida ||
            data?.estatusId !== ESTATUS_SALIDA.AUTORIZADO
        ) {
            return null;
        }

        return (
            <div className="d-flex align-items-center justify-content-center">
                <button
                    title="Registrar salida"
                    type="button"
                    className="button-icon"
                    onClick={() => registrarSalida(data.id)}
                >
                    <i className="pi pi-sign-out text-primary" />
                </button>
            </div>
        );
    };

    const renderFooterRechazo = () => (
        <div>
            <Button
                label="Cerrar"
                onClick={() => setVerModalRechazo(false)}
                className="p-button-outlined"
            />

            <Button label="Rechazar" onClick={rechazar} autoFocus />
        </div>
    );

    return (
        <div className="main-screen caja">
            <FormFilter
                columns={8}
                filter={filter}
                onChange={onFilterChange}
                onClear={onClear}
                onFilter={filtrar}
            >
                <Filters>
                    <Field
                        field="fecha"
                        label="Fecha salida"
                        render={FormCalendarRange}
                        cols={2}
                    />

                    <Field
                        field="empleadoId"
                        label="Empleado"
                        cols={2}
                        render={(props) => (
                            <FormDropDown
                                {...props}
                                source="empleados"
                                params={{
                                    todasLasEmpresas: true,
                                }}
                                valueById
                            />
                        )}
                    />

                    <Field
                        field="tipoId"
                        label="Tipo salida"
                        cols={2}
                        render={(props) => (
                            <FormDropDown
                                {...props}
                                source="tiposSalidaEmpleado"
                                valueById
                            />
                        )}
                    />

                    <Field
                        field="estatusId"
                        label="Estatus"
                        cols={2}
                        render={(props) => (
                            <FormDropDown
                                {...props}
                                source="estatusSalidaEmpleado"
                                valueById
                            />
                        )}
                    />
                </Filters>

                <Buttons filter={true} clear={true} />
            </FormFilter>

            <div className="ag-theme-balham grid-principal">
                <AgGridReact
                    components={{
                        buttonsHeader: ButtonsHeader,
                        buttonsDetail: ButtonsDetail,
                        dateTimeCellRenderer: DateTimeCellRenderer,
                        autorizarCellRenderer: AutorizarCellRenderer,
                        rechazarCellRenderer: RechazarCellRenderer,
                        salidaCellRenderer: SalidaCellRenderer,
                    }}
                    onGridReady={() => filtrar(filter).then()}
                    rowData={datos}
                    overlayLoadingTemplate={agGridHelper.loadingOverlay}
                    defaultColDef={agGridHelper.defaultColumns}
                    context={{
                        onEdit: editar,
                    }}
                    rowHeight={40}
                >
                    <AgGridColumn
                        field="fechaHoraSalida"
                        headerName="Fecha salida"
                        cellClass="center"
                        cellRenderer="dateTimeCellRenderer"
                        minWidth={180}
                    />

                    <AgGridColumn
                        field="nombreCompleto"
                        headerName="Empleado"
                        flex={3}
                        minWidth={200}
                    />

                    <AgGridColumn
                        field="departamento"
                        headerName="Departamento"
                        flex={2}
                        minWidth={150}
                    />

                    <AgGridColumn
                        field="destino"
                        headerName="Destino"
                        flex={2}
                        minWidth={150}
                    />

                    <AgGridColumn
                        field="tipoSalida"
                        headerName="Tipo salida"
                        flex={2}
                        minWidth={180}
                    />

                    <AgGridColumn
                        field="estatus"
                        headerName="Estatus"
                        flex={2}
                        minWidth={130}
                    />

                    <AgGridColumn
                        maxWidth={120}
                        headerName="Autorizar"
                        hide={!esAutorizar}
                        cellRenderer="autorizarCellRenderer"
                    />

                    <AgGridColumn
                        maxWidth={120}
                        headerName="Rechazar"
                        hide={!esAutorizar}
                        cellRenderer="rechazarCellRenderer"
                    />

                    <AgGridColumn
                        maxWidth={150}
                        headerName="Registrar salida"
                        hide={!esSalida}
                        cellRenderer="salidaCellRenderer"
                    />

  {!ocultarEditar && (
    <AgGridColumn
        maxWidth={80}
        headerName="Ver"
        pinned="right"
        headerComponent="buttonsHeader"
        cellClass="left"
        cellRenderer="buttonsDetail"
    />
)}
                </AgGridReact>
            </div>

            <SalidasEmpleadoDetalle
                salidaEmpleadoId={salidaEmpleadoId}
                puedeEditar={puedeEditar}
                onSaved={() => {
                    filtrar(filter).then();
                    setSalidaEmpleadoId(null);
                }}
                onCancel={() => setSalidaEmpleadoId(null)}
            />

            <Dialog
                header="Rechazar pase de salida"
                visible={verModalRechazo}
                footer={renderFooterRechazo}
                style={{ width: "50vw" }}
                onHide={() => setVerModalRechazo(false)}
            >
                <FieldTextArea
                    name="comentarios"
                    label="Comentarios"
                    colMd={12}
                    rows={3}
                    value={comentarioRechazo}
                    onChange={(value) => setComentarioRechazo(value)}
                />
            </Dialog>
        </div>
    );
};

export default SalidasEmpleado;